import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { IKeyValue } from '../../types';

const KeyValue = (props: IKeyValue) => {
  const { title, description, rightIcon, containerClass } = props;
  const isDescriptionString = typeof description === 'string';
  return (
    <div className={`flex mb-3 ${containerClass}`}>
      <Typography color="var(--grayscale-3)" variant="p3" className="w-[164px]">
        {title}
      </Typography>
      {isDescriptionString ? (
        <Typography
          color="var(--grayscale-2)"
          variant="p3"
          className={`font-medium flex flex-1 ${styles.breakWord}`}
        >
          {description ?? '-'}
          {rightIcon ? rightIcon : null}
        </Typography>
      ) : (
        description ?? '-'
      )}
    </div>
  );
};

export default KeyValue;
